module.exports = __webpack_public_path__ + "img/1.16267fd4.jpg";